import { render, staticRenderFns } from "./SystemDesign.vue?vue&type=template&id=2f279f20&scoped=true"
import script from "./SystemDesign.vue?vue&type=script&lang=js"
export * from "./SystemDesign.vue?vue&type=script&lang=js"
import style0 from "./SystemDesign.vue?vue&type=style&index=0&id=2f279f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f279f20",
  null
  
)

export default component.exports